import { button } from '../../../../../component/component'

export default function(o,p){

  var reset = function(){

    if(div.getDisabled()){
      return
    }

    if(p.abort){
      p.abort()
    }

  }

  var disabled = !!p.item

  var div =
    button(null,'fi-x',disabled)
    .addClass('mousetrapEsc')
    .css({
      position: 'absolute',
      right: '34px',
    })
    .click(reset)

  return div

}


// WEBPACK FOOTER //
// ./src/client/view/admin/edit/form/cancel/cancel.js